import { render, staticRenderFns } from "./ContentBlock.vue?vue&type=template&id=5e407347&scoped=true&"
import script from "./ContentBlock.vue?vue&type=script&lang=ts&"
export * from "./ContentBlock.vue?vue&type=script&lang=ts&"
import style0 from "./ContentBlock.vue?vue&type=style&index=0&id=5e407347&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e407347",
  null
  
)

export default component.exports